<!-- 公告栏组件 -->
<template>
  <header class="top-bar">
    <div class="info">
      <div class="brand-wrap" @click.stop="toPage('/index')">
        <div class="brand-main">
          <img
              :src="publicLogo"
              class="left-img fallback-logo"
              alt="全游荟">
          <span class="brand-copy">
            <span class="brand-note">游戏资产专业中心</span>
            <span class="brand-slogan">全国游戏资产交易市场</span>
          </span>
        </div>
      </div>

      <div class="center">
        <div class="center-left" @click.stop="hide('showPopup1', 'showPopup2')">
          <el-text class="text" :class="{act: showPopup.showPopup1}">
            {{ Object.keys(game).length > 0 ? game.gameName : '全部游戏' }}
          </el-text>
          <el-icon size="14" :color="showPopup.showPopup1 ? '#3579FF' : '#7a8aa0'">
            <CaretTop v-if="showPopup.showPopup1" />
            <CaretBottom v-else />
          </el-icon>
        </div>
        <div class="center-input" @click.stop="">
          <el-input
              v-model="keyword"
              @focus.stop="hide('showPopup2', 'showPopup1')"
              placeholder="请输入商品编号或标题关键词" />
        </div>
        <button class="center-right" type="button" @click="toSearch">
          <img src="@/assets/index/search.png" alt="">
        </button>

        <div class="center-popup1" v-show="showPopup.showPopup2">
          <div class="inner">
            <div class="inner-top">
              <div class="left-text">历史搜索</div>
              <el-icon size="14" v-if="searchList.length > 0" @click="clearSearch">
                <Delete />
              </el-icon>
            </div>
            <div class="inner-tags" v-if="searchList.length > 0">
              <button
                  class="inner-tag"
                  v-for="(item, index) in searchList"
                  :key="index"
                  type="button"
                  @click.stop="addSearchRecord(item)">
                {{ item }}
              </button>
            </div>
            <div class="search-spacer" :class="{empty: !searchList.length}"></div>
            <div class="inner-top">
              <div class="left-text">猜你想搜</div>
            </div>
            <div class="inner-games">
              <button
                  class="inner-game"
                  v-for="(item, index) in recommendSearchList"
                  :key="index"
                  type="button"
                  @click.stop="addSearchRecord(item.content)">
                <span class="text1">热</span>
                <span class="text2">{{ item.content }}</span>
              </button>
            </div>
          </div>
        </div>

        <div class="center-popup" v-show="showPopup.showPopup1" @click.stop="">
          <gameGridLetter @clickItem="changeGame" type="text" :list="indexLists" />
        </div>
      </div>

      <nav class="right">
        <button class="right-item" type="button" @click="downloadApp">
          <img src="@/assets/index/app.png" class="img" alt="">
          <span class="text">下载APP</span>
        </button>
        <button class="right-item" type="button" @click="toPage('/message')">
          <img src="@/assets/index/msg.png" class="img" alt="">
          <span class="text">消息</span>
        </button>
        <button class="right-item" type="button" @click="toPage('/collect')">
          <img src="@/assets/index/sc.png" class="img" alt="">
          <span class="text">收藏</span>
        </button>
        <button class="right-item" type="button" @click="toPage('/history')">
          <img src="@/assets/index/lishi.png" class="img" alt="">
          <span class="text">历史</span>
        </button>
        <button class="right-item" type="button" @click="goPage()">
          <img src="@/assets/index/my.png" class="img" alt="">
          <span class="text">我的</span>
        </button>
      </nav>
    </div>

    <el-dialog
        top="18%"
        v-model="showWym"
        :show-close="false"
        class="dialog dialog2">
      <div slot="title" class="dialog-title">
        <div class="title-text">我要卖</div>
        <el-icon @click="showWym = false" size="20">
          <CircleClose />
        </el-icon>
      </div>
      <div class="dialog-inner dialog-inner1">
        <div class="dialog-inner-item" @click="handleZj()" v-if="false">
          <div class="title-text">中介担保</div>
          <div class="sub-text">安全靠谱</div>
        </div>
        <div class="dialog-inner-item dialog-inner-item1" @click="toSelect(2)">
          <div class="title-text">发布资产</div>
          <div class="sub-text">资产一键发布</div>
          <img src="@/assets/commonPc/chushou.png" class="inner-img" alt="">
        </div>
        <div class="dialog-inner-item dialog-inner-item2" @click="toSelect(1)">
          <div class="title-text">竞拍资产</div>
          <div class="sub-text">发布竞拍 快速升值</div>
          <img src="@/assets/commonPc/jingpai.png" class="inner-img" alt="">
        </div>
      </div>
    </el-dialog>

    <el-dialog
        top="18%"
        v-model="showSm"
        :show-close="false"
        class="dialog dialog3"
        :close-on-click-modal="false"
        width="20%">
      <div slot="title" class="dialog-title">
        <div class="title-text">实名认证</div>
        <el-icon class="el-icon" size="20" color="#969696" @click="showSm = false">
          <CircleClose />
        </el-icon>
      </div>
      <div class="dialog-inner2">
        <img src="@/assets/commonPc/smrz.png" class="inner-img" alt="">
        <div class="inner-text">根据相关法律法规要求<br>需完成实名认证后方可进行后续流程</div>
        <el-button type="primary" class="confirm-btn" @click.stop="smClick">立即实名</el-button>
      </div>
    </el-dialog>
  </header>
</template>

<script setup>
import {inject, onMounted, reactive, ref} from 'vue'
import {storeToRefs} from 'pinia'
import {common} from '@/composables/common'
import {useUserStore} from '@/stores/user'
import {useHomeCacheStore} from '@/stores/homeCache'
import router from '@/router'
import {ElMessageBox, ElMessage} from 'element-plus'
import gameGridLetter from '@/components/game-grid-letter.vue'
import {eventBus} from '@/util/eventBus'

const $http = inject('$http')
const store = useUserStore()
const cacheStore = useHomeCacheStore()
const {toPage} = common()
const publicLogo = `${process.env.BASE_URL || '/'}logo.webp`

const showWym = ref(false)
const showSm = ref(false)
const showPopup = reactive({
  showPopup1: false,
  showPopup2: false
})
const keyword = ref('')
const {gameAllList: indexLists} = storeToRefs(cacheStore)
let searchList = reactive([])
const recommendSearchList = reactive([])
const config = reactive({})
let game = {}

onMounted(() => {
  getHistoryList()
  getGameAllList()
  getConfiguration()
  getSearchLog()
  eventBus.on('clickBody', () => {
    showPopup.showPopup1 = false
    showPopup.showPopup2 = false
  })
  eventBus.on('wym', () => {
    if (!store.isLogin) {
      toPage('/login')
      return
    }
    showWym.value = true
  })
})

const hide = (show, hideName) => {
  showPopup[show] = !showPopup[show]
  showPopup[hideName] = false
}

const goPage = () => {
  toPage('/buy', true)
}

const getHistoryList = () => {
  if (!store.userId) {
    searchList.length = 0
    return
  }
  const key = `searchList_${store.userId}`
  const searchList1 = localStorage.getItem(key)
  if (searchList1 && searchList1.length > 0) {
    try {
      const parsed = JSON.parse(searchList1)
      if (Array.isArray(parsed)) {
        searchList.length = 0
        searchList.push(...parsed)
      } else {
        searchList.length = 0
      }
    } catch (e) {
      searchList.length = 0
    }
  } else {
    searchList.length = 0
  }
}

const clearSearch = () => {
  ElMessageBox.confirm('确定删除历史搜索?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    localStorage.removeItem(`searchList_${store.userId}`)
    searchList.length = 0
  }).catch(() => {
  })
}

const addSearchRecord = (keywords) => {
  const key = `searchList_${store.userId}`
  const searchList = localStorage.getItem(key)
  if (searchList) {
    const searchList1 = JSON.parse(searchList)
    const index = searchList1.indexOf(keywords)
    if (index === -1) {
      searchList1.unshift(keywords)
    } else {
      searchList1.splice(index, 1)
      searchList1.unshift(keywords)
    }
    localStorage.setItem(key, JSON.stringify(searchList1))
  } else {
    const arr = [keywords]
    localStorage[key] = JSON.stringify(arr)
  }
  router.push({
    path: '/search',
    query: {
      title: keywords,
      gameId: `${game.id || ''}`
    },
    replace: true
  })
  keyword.value = keywords
  showPopup.showPopup2 = false
}

const toSearch = () => {
  if (!keyword.value) return ElMessage.error('请输入搜索内容')
  addSearchRecord(keyword.value)
}

const toSelect = (type = 3, needLogin = true, goodsType = '') => {
  if (!store.isLogin && needLogin) {
    toPage('/login')
    return
  }
  if (type !== 3) {
    if (store.user.payAuthentication === '1') {
      showSm.value = true
      return
    }
  }
  showWym.value = false
  const query = {
    type
  }
  if (goodsType) query.goodsType = goodsType
  router.push({
    path: '/select-game',
    query
  })
}

const getGameAllList = () => {
  cacheStore.loadGameAllList()
}

const getConfiguration = () => {
  const params = {
    id: 1
  }
  $http.post('sys/sensitiveWords/loadById', params).then(res => {
    if (res.code === 200) {
      Object.assign(config, res.data)
    }
  })
}

const getSearchLog = () => {
  const params = {}
  $http.post('sys/searchLog/loadPageList', params).then(res => {
    if (res.code === 200) {
      recommendSearchList.length = 0
      recommendSearchList.push(...res.data)
    }
  })
}

const handleZj = () => {
  if (store.user.payAuthentication === '1') {
    showWym.value = false
    showSm.value = true
  } else {
    showWym.value = false
    showSm.value = false
    toPage('/zjdb')
  }
}

const smClick = () => {
  showSm.value = false
  router.push({
    path: '/real-name'
  })
}

const changeGame = (item) => {
  game = item
  showPopup.showPopup1 = false
}

const downloadApp = () => {
  const url = 'https://www.pgyer.com/quanyouhui'
  const newWin = window.open(url, '_blank')
  if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
    window.location.href = url
  }
}
</script>

<style scoped lang="scss">
.top-bar {
  min-height: 112px;
  flex-shrink: 0;
  width: 100%;
  background: linear-gradient(180deg, #eaf4ff 0%, #edf6ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 20;

  .info {
    width: min(calc(100vw - 160px), 1400px);
    display: grid;
    grid-template-columns: 330px minmax(560px, 1fr) 300px;
    align-items: center;
    gap: 28px;
  }
}

.brand-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  cursor: pointer;
  width: 330px;
  min-width: 0;
}

.brand-main {
  display: flex;
  align-items: center;
  gap: 2px;
  width: 100%;
  min-width: 0;
}

.left-img {
  width: 136px;
  height: 60px;
  flex: 0 0 auto;
  object-fit: contain;
  object-position: left center;
  display: block;

  &.fallback-logo {
    width: 132px;
    height: 60px;
  }
}

.brand-copy {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.brand-note,
.brand-slogan {
  color: #0a3678;
  font-family: alimamashuheiti, Medium, Arial, sans-serif;
  font-size: 14px;
  font-weight: 900;
  line-height: 19px;
  letter-spacing: 0;
  white-space: nowrap;
}

.center {
  height: 54px;
  display: flex;
  align-items: center;
  border: 1px solid rgba(143, 184, 255, 0.62);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 10px 24px rgba(42, 101, 191, 0.07);
  box-sizing: border-box;
  position: relative;
  overflow: visible;

  .center-left {
    width: 136px;
    height: 100%;
    padding: 0 18px 0 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-right: 1px solid rgba(143, 184, 255, 0.42);
    cursor: pointer;

    .text {
      color: #09152f;
      font-size: 14px;
      font-weight: 800;
      font-family: Medium, Arial, sans-serif;
      white-space: nowrap;

      &.act {
        color: #3579ff;
      }
    }
  }

  .center-input {
    flex: 1;
    min-width: 0;

    :deep(.el-input) {
      height: 100%;

      .el-input__wrapper {
        height: 52px;
        border: none;
        box-shadow: none;
        background: transparent;
        font-size: 15px;
        font-family: Regular, Arial, sans-serif;
        font-weight: 500;
        padding: 0 16px;
      }

      .el-input__inner::placeholder {
        color: #9aa8bd;
        font-weight: 500;
      }
    }
  }

  .center-right {
    width: 74px;
    height: 46px;
    border: 0;
    border-radius: 14px;
    margin-right: 4px;
    background: linear-gradient(135deg, #2b7cff, #1268e9);
    box-shadow: 0 8px 18px rgba(43, 124, 255, 0.24);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
      width: 24px;
      height: 24px;
      filter: brightness(0) invert(1);
    }
  }
}

.center-popup1,
.center-popup {
  position: absolute;
  top: 66px;
  left: 0;
  width: 100%;
  background: #fff;
  border: 1px solid rgba(143, 184, 255, 0.3);
  border-radius: 16px;
  box-shadow: 0 18px 40px rgba(42, 101, 191, 0.12);
  z-index: 100;
}

.center-popup1 {
  .inner {
    padding: 20px;
  }

  .inner-top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left-text {
      color: #09152f;
      font-size: 14px;
      font-family: alimamashuheiti;
    }
  }

  .inner-tags {
    display: flex;
    flex-wrap: wrap;
    margin-top: 12px;
    gap: 10px;
  }

  .inner-tag {
    border: 0;
    background: #f3f7ff;
    color: #53637c;
    font-size: 14px;
    padding: 6px 12px;
    border-radius: 8px;
    cursor: pointer;
  }

  .search-spacer {
    height: 15px;

    &.empty {
      height: 20px;
    }
  }

  .inner-games {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 10px;
  }

  .inner-game {
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    height: 40px;
    cursor: pointer;
    text-align: left;

    .text1 {
      color: #fff;
      font-size: 12px;
      background: linear-gradient(180deg, #3579ff, #35abff);
      border-radius: 6px;
      padding: 2px 4px;
      margin-right: 8px;
    }

    .text2 {
      color: #53637c;
      font-size: 14px;
    }
  }
}

.center-popup {
  width: 720px;
  padding: 20px;

  :deep(.top) {
    background: #f5f8ff;
    border-radius: 10px;
    height: 30px;
    display: flex;
    align-items: center;
    padding: 0 5px;
  }

  :deep(.inner) {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    margin-top: 20px;
  }
}

.right {
  display: flex;
  justify-content: flex-end;
  gap: 30px;
}

.right-item {
  width: 56px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #09152f;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  position: relative;

  .img {
    width: 28px;
    height: 28px;
    object-fit: contain;
    display: block;
    margin: 0 auto 6px;
  }

  .text {
    display: block;
    white-space: nowrap;
  }
}

:deep(.dialog) {
  border-radius: 20px;
  padding: 0;

  .el-dialog__header {
    padding-bottom: 0;
  }
}

:deep(.dialog2) {
  width: 560px;
}

:deep(.dialog3) {
  border-radius: 20px;

  .dialog-inner2 {
    padding: 30px 0 50px;

    .inner-img {
      width: 89px;
      margin: 0 auto;
      display: block;
    }

    .inner-text {
      text-align: center;
      color: #969696;
      font-size: 20px;
      margin-top: 30px;
    }

    .confirm-btn {
      margin-left: 25%;
      margin-top: 40px;
      width: 50%;
      height: 60px;
      border-radius: 12px;
      font-size: 24px;
    }
  }
}

.dialog-title {
  position: relative;
  padding: 30px 0;

  .title-text {
    font-weight: bold;
    color: #151515;
    font-size: 24px;
    width: 100%;
    text-align: center;
  }

  .el-icon {
    position: absolute;
    right: 30px;
    top: 30px;
    cursor: pointer;
  }
}

.dialog-inner {
  margin-top: 40px;
}

.dialog-inner1 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 0 30px;
  padding: 20px 60px 60px;
  margin-top: 0;

  .dialog-inner-item {
    height: 250px;
    text-align: center;
    padding: 30px 0 0;
    cursor: pointer;
    border-radius: 20px;

    &.dialog-inner-item1 {
      background: linear-gradient(0deg, #c6d9ff, #f0f6ff);
    }

    &.dialog-inner-item2 {
      background: linear-gradient(0deg, #ffcfc5, #fff1ec);
    }

    .title-text {
      font-weight: bold;
      color: #151515;
      font-size: 24px;
    }

    .sub-text {
      color: #80716d;
      font-size: 18px;
      margin: 20px 0 40px;
    }

    .inner-img {
      width: 74px;
      height: 74px;
    }
  }
}

@media (max-width: 1919px) {
  .top-bar .info {
    width: min(calc(100vw - 96px), 1360px);
    grid-template-columns: 320px minmax(520px, 1fr) 280px;
    gap: 22px;
  }

  .left-img {
    width: 132px;
    height: 58px;

    &.fallback-logo {
      width: 128px;
      height: 58px;
    }
  }

  .brand-wrap {
    width: 320px;
  }

  .right {
    gap: 16px;
  }
}

@media (max-width: 1439px) {
  .top-bar .info {
    width: min(calc(100vw - 64px), 1320px);
    grid-template-columns: 300px minmax(460px, 1fr) 260px;
    gap: 16px;
  }

  .left-img {
    width: 120px;
    height: 54px;

    &.fallback-logo {
      width: 118px;
      height: 54px;
    }
  }

  .brand-wrap {
    width: 300px;
  }

  .brand-main {
    gap: 2px;
  }

  .brand-note,
  .brand-slogan {
    font-size: 13px;
    font-weight: 900;
    line-height: 18px;
  }

  .right {
    gap: 10px;
  }
}
</style>
